import { render, staticRenderFns } from "./AddEditContact.vue?vue&type=template&id=ce4d3df2&scoped=true&"
import script from "./AddEditContact.vue?vue&type=script&lang=js&"
export * from "./AddEditContact.vue?vue&type=script&lang=js&"
import style0 from "./AddEditContact.vue?vue&type=style&index=0&id=ce4d3df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4d3df2",
  null
  
)

export default component.exports